export default __webpack_public_path__ + "c1e0b607b0e1be95a28ad0d55022e7d7.png";